module.exports = __webpack_public_path__ + "img/logo.e1b64f58.png";